import { Component, Input } from '@angular/core';
import { EaBreadcrumb } from '@app/components/pr-breadcrumb/pr-breadcrumb.component';

@Component({
    selector: 'pr-page-header-opti',
    templateUrl: './pr-page-header-opti.component.html',
    styleUrls: ['./pr-page-header-opti.component.scss'],
    standalone: false
})
export class PrPageHeaderOptiComponent {
  @Input() breadcrumb: EaBreadcrumb[];
  @Input() title: string;
  @Input() subTitle: string;
  @Input() optimizationLabel: string;
  @Input() optimizationType: string;
  @Input() menus: {
    synthese: { url: string; label: string; current: boolean };
    label: string;
    items: Array<{ url: string; label: string; current: boolean }>;
  };

  constructor() {}
}
